import * as React from 'react'
import { Box, Divider, Grid, Paper, Stack, Typography } from '@mui/material'
import { selects, globalDataConfig } from '../restrictions.model'
import {
  addonRights,
  includedRights,
  isRightInCustomerData,
} from '../rights-sections'
import { RightsType } from 'services/cm-api/get-customer'
import CreateInputElement from './create-input-element'

function Rights({ data, search }: { data: RightsType; search: string }) {
  const searchFilter = (item) => {
    return item.label.toLowerCase().includes(search.toLowerCase())
  }

  // ENG2-2457 (T2): two groups, memberships and order from the model
  // (rights-sections.ts). Browser Extension is hidden.
  const groupTitleSx = {
    mb: 1.5,
    fontWeight: 600,
    textTransform: 'uppercase',
    fontSize: '0.7rem',
    letterSpacing: '0.5px',
  }

  // Global Data carries two date pickers and Risika for AI one (ENG2-2614),
  // so a right with a date sub-config gets a wider cell.
  const cellWidth = (right: { key: string; endDate?: unknown }) =>
    right.key === globalDataConfig.key || right.endDate
      ? { xs: 12, sm: 6, md: 4 }
      : { xs: 6, sm: 4, md: 3 }

  const renderToggleGroup = (items, title: string, muted = false) => {
    const filtered = items
      .filter(searchFilter)
      .filter((item) =>
        isRightInCustomerData(
          item.key,
          data as unknown as Record<string, unknown>,
        ),
      )
    if (filtered.length === 0) return null

    return (
      <Box data-testid="rights-group">
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={groupTitleSx}
        >
          {title}
        </Typography>
        <Grid container spacing={1}>
          {filtered.map((right) => (
            <Grid key={right.key} item {...cellWidth(right)}>
              <CreateInputElement
                key={right.key}
                element={right}
                data={data}
                muted={muted}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    )
  }

  const filteredSelects = selects.filter(searchFilter)

  return (
    <Paper
      variant="outlined"
      sx={{
        width: '100%',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 2,
          bgcolor: 'action.hover',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          Rights
        </Typography>
      </Box>

      <Stack sx={{ p: 3 }} spacing={3}>
        {renderToggleGroup(includedRights(), 'Included in every package', true)}
        {renderToggleGroup(addonRights(), 'Add-ons')}

        {filteredSelects.length > 0 && (
          <>
            <Divider />
            <Box>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{
                  mb: 2,
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  fontSize: '0.7rem',
                  letterSpacing: '0.5px',
                }}
              >
                Configuration
              </Typography>
              <Grid container spacing={2}>
                {filteredSelects.map((right) => (
                  <Grid key={right.key} item xs={12} sm={6} md={4}>
                    <CreateInputElement
                      key={right.key}
                      element={right}
                      data={data}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </>
        )}
      </Stack>
    </Paper>
  )
}

export default Rights
